"use client";

import styled, { css } from "styled-components";

const contentWidth = 670;

const contentWidthCss = css`
  max-width: ${contentWidth}px;
  margin: 0 auto;
`;

export const BlogPost = styled.article`
  margin: 0 auto;
  padding: 160px 0;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  blockquote,
  table,
  hr {
    ${contentWidthCss}
  }

  h1 {
    font-size: 34px;
    font-weight: 600;
    margin-bottom: 32px;
    max-width: ${contentWidth}px;
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 12px;
    max-width: ${contentWidth}px;
  }

  p,
  li {
    font-size: 18px;
    line-height: 1.6;
  }

  p:not(:last-of-type) {
    margin-bottom: 32px;
  }

  p + h2,
  p + h3,
  p + h4,
  p + h5,
  p + h6 {
    margin-top: 64px;
  }
`;

export const BlogHeader = styled.header`
  ${contentWidthCss}
  margin-bottom: 64px;
`;

export const BlogContent = styled.main``;
